/*
  Words to Charm the World — archive renderer (vanilla, no dependencies)
  Reads window.AW_QUOTES (injected by sections/words-archive.liquid) and renders
  the editorial gallery: featured quote, search, theme + season filters,
  surprise me, share, graphic-only cards, and background images.
  Drop this in assets/words-archive.js
*/
(function () {
  'use strict';

  var TM = {
    inspiration:    { label: 'Inspiration',    color: '#a9772a', bg: '#f6eeda', dot: '#caa24a' },
    empowerment:    { label: 'Empowerment',    color: '#a8497b', bg: '#f6e4ee', dot: '#c9709f' },
    love:           { label: 'Love',           color: '#bd4a3b', bg: '#f8e4dd', dot: '#d77163' },
    humor:          { label: 'Humor',          color: '#2f7d86', bg: '#dceef0', dot: '#5aa3ab' },
    sustainability: { label: 'Sustainability', color: '#4f7a43', bg: '#e7efdd', dot: '#6f9a52' }
  };
  var MONF = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var MON  = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function themesOf(q) { return (q.themes && q.themes.length) ? q.themes : ['inspiration']; }
  function fmt(d) { if (!d) return ''; var p = d.split('-'); return MON[+p[1]-1] + ' ' + (+p[2]) + ', ' + p[0]; }
  // Format-agnostic sort key: YYYYMMDD as a number. Handles padded/unpadded
  // (2026-6-8), ISO datetimes (2026-06-08T..), and slashes. Undated => -1 (sorts last).
  // Today as a YYYYMMDD number, in the visitor's local time.
  function todayKey() {
    var n = new Date();
    return n.getFullYear() * 10000 + (n.getMonth() + 1) * 100 + n.getDate();
  }
  // A quote is live once its date has arrived. Future-dated quotes stay scheduled
  // (hidden) until that day; undated quotes have nothing to schedule, so they show.
  function isLive(q) { return dateKey(q) <= todayKey(); }

  function dateKey(q) {
    var d = (q && q.date ? String(q.date) : '').trim();
    if (!d) return -1;
    var m = d.match(/(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})/);
    if (m) return (+m[1]) * 10000 + (+m[2]) * 100 + (+m[3]);
    var t = Date.parse(d);
    if (!isNaN(t)) { var dt = new Date(t); return dt.getFullYear() * 10000 + (dt.getMonth() + 1) * 100 + dt.getDate(); }
    return -1;
  }
  function kick(q) {
    if (!q.date) return (q.occasion || 'From the archive').toUpperCase();
    var p = q.date.split('-'); var s = MONF[+p[1]-1] + ' ' + (+p[2]) + ', ' + p[0];
    if (q.occasion) s += '  \u00b7  ' + q.occasion;
    return s.toUpperCase();
  }
  function seasonOf(q) {
    if (!q.date) return '';
    var m = +q.date.split('-')[1];
    return (m <= 2 || m === 12) ? 'winter' : m <= 5 ? 'spring' : m <= 8 ? 'summer' : 'fall';
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
    return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  // Fold smart punctuation + accents to plain ASCII so typed text matches the quotes.
  function norm(s) {
    return String(s == null ? '' : s)
      .toLowerCase()
      .replace(/[\u2018\u2019\u201A\u201B]/g, "'")   // curly single quotes -> '
      .replace(/[\u201C\u201D\u201E\u201F]/g, '"')   // curly double quotes -> "
      .replace(/[\u2010-\u2015]/g, '-')               // hyphens / en / em dashes -> -
      .normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // strip accents
  }

  ready(function () {
    var mount = document.getElementById('words-archive');
    if (!mount) return;
    injectStyles();
    var cfg = window.AW_CONFIG || {};
    var DATA = [];
    var fontLink = document.createElement('link');
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Newsreader:ital,wght@0,300;0,400;1,300;1,400&family=Jost:wght@300;400;500&display=swap';
    document.head.appendChild(fontLink);

    var state = { q: '', theme: 'all', season: 'all', spotlightId: null };

    function passesFilters(q) {
      if (!isLive(q)) return false;
      if (state.theme !== 'all' && themesOf(q).indexOf(state.theme) === -1) return false;
      if (state.season !== 'all' && seasonOf(q) !== state.season) return false;
      if (state.q) {
        var hay = norm(q.text + ' ' + q.author + ' ' + q.occasion + ' ' + (q.caption || ''));
        // every typed word must appear (order-independent), punctuation/accents folded
        var terms = norm(state.q).split(/\s+/).filter(Boolean);
        for (var i = 0; i < terms.length; i++) {
          if (hay.indexOf(terms[i]) === -1) return false;
        }
      }
      return true;
    }
    function results() {
      return DATA.filter(passesFilters).sort(function (a, b) { return dateKey(b) - dateKey(a); });
    }
    function featured() {
      if (state.spotlightId) {
        var f = DATA.filter(function (q) { return q.id === state.spotlightId; })[0];
        if (f) return f;
      }
      var dated = DATA.filter(function (q) { return dateKey(q) > 0 && isLive(q); }).sort(function (a, b) { return dateKey(b) - dateKey(a); });
      return dated[0] || DATA.filter(isLive)[0] || DATA[0];
    }
    function liveData() { return DATA.filter(isLive); }
    function countTheme(k) {
      var live = liveData();
      if (k === 'all') return live.length;
      return live.filter(function (q) { return themesOf(q).indexOf(k) !== -1; }).length;
    }
    function countSeason(k) {
      var live = liveData();
      if (k === 'all') return live.length;
      return live.filter(function (q) { return seasonOf(q) === k; }).length;
    }

    function toast(msg) {
      var t = mount.querySelector('.awq-toast');
      if (!t) { t = document.createElement('div'); t.className = 'awq-toast'; mount.appendChild(t); }
      t.textContent = msg; t.classList.add('is-on');
      clearTimeout(t._timer); t._timer = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
    }
    function share(q) {
      var txt = '\u201c' + q.text + '\u201d' + (q.author ? ' \u2014 ' + q.author : '');
      var full = txt + '  \u00b7  alexwoo.com';
      if (navigator.share) { navigator.share({ text: full }).catch(function () {}); return; }
      if (navigator.clipboard) { navigator.clipboard.writeText(full).then(function () { toast('Copied to share  \u2726'); }); }
      else { toast('Copied to share  \u2726'); }
    }

    function render() {
      var f = featured();
      var fThemes = themesOf(f);
      var fm = TM[fThemes[0]] || TM.inspiration;
      var list = results();
      /* the featured quote is shown in the hero above — drop it from the grid so it isn't duplicative */
      var gridList = list.filter(function (q) { return q.id !== f.id; });

      var html = '';

      /* intro */
      html += '<div class="awq-intro">'
        + '<p>For the last five years, uplifting and seasonal words have welcomed visitors to Alex Woo Jewelry. Inspired by the belief that small things can carry great meaning, these curated quotes celebrate optimism, imagination, resilience, and joy. Gathered here for the first time, they form a collection of words to inspire, encourage, and Charm The World\u2122.</p>'
        + '</div>';

      /* featured */
      if (f.graphic && f.image) {
        html += '<div class="awq-hero awq-hero--graphic">'
          + '<span class="awq-hero-status">' + (state.spotlightId ? 'A surprise from the archive' : 'Currently in our banner') + '</span>'
          + '<img src="' + esc(f.image) + '" alt="' + esc(f.caption) + '">'
          + '</div>';
      } else {
        var heroStyle = 'background:' + fm.bg + ';border-color:' + fm.color + '4d;';
        var bg = (f.image ? '<span class="awq-hero-bg" style="background-image:url(' + esc(f.image) + ')"></span><span class="awq-hero-scrim"></span>' : '');
        html += '<div class="awq-hero" style="' + heroStyle + '">'
          + bg
          + '<div class="awq-hero-inner">'
          + '<div class="awq-hero-status">' + (state.spotlightId ? 'A surprise from the archive' : 'Currently in our banner') + '</div>'
          + '<div class="awq-hero-kicker" style="color:' + fm.color + '"><i class="awq-dot" style="background:' + fm.dot + '"></i>' + esc(kick(f)) + '</div>'
          + '<blockquote class="awq-hero-quote">\u201c' + esc(f.text) + '\u201d</blockquote>'
          + (f.author ? '<div class="awq-hero-author">' + esc(f.author) + '</div>' : '')
          + (f.caption ? '<div class="awq-hero-note">' + esc(f.caption) + '</div>' : '')
          + '</div></div>';
      }
      /* featured actions */
      html += '<div class="awq-hero-actions">'
        + '<button class="awq-link" data-share="' + esc(f.id) + '">Share this quote</button>'
        + '<button class="awq-link awq-link--mauve" data-random="1">Surprise me</button>'
        + (state.spotlightId ? '<button class="awq-link awq-link--mute" data-clear="1">\u2190 Back to current</button>' : '')
        + '</div>';

      /* controls */
      html += '<div class="awq-controls">';
      html += '<div class="awq-field awq-field--search"><label>Search</label>'
        + '<input class="awq-search" type="search" placeholder="Search words, people, occasions\u2026" value="' + esc(state.q) + '"></div>';
      html += '<div class="awq-filterline">';
      html += '<div class="awq-field"><label>Theme</label><div class="awq-chiprow">' + chip('theme', 'all', 'All');
      ['inspiration','empowerment','love','humor','sustainability'].forEach(function (k) { html += chip('theme', k, TM[k].label); });
      html += '</div></div>';
      html += '<div class="awq-field"><label>Season</label><div class="awq-chiprow">'
        + chip('season','spring','Spring') + chip('season','summer','Summer')
        + chip('season','fall','Fall') + chip('season','winter','Winter') + '</div></div>';
      html += '</div>';
      html += '</div>';

      /* archive header */
      html += '<div class="awq-archhead"><h2>The Archive</h2><div class="awq-count">' + gridList.length + ' of ' + Math.max(0, liveData().length - 1) + ' quotes</div></div>';

      /* grid */
      if (gridList.length) {
        html += '<div class="awq-grid">';
        gridList.forEach(function (q) { html += card(q); });
        html += '</div>';
      } else {
        html += '<div class="awq-empty"><div class="awq-empty-h">No quotes match just yet.</div>'
          + '<button class="awq-clear" data-clearfilters="1">Clear filters</button></div>';
      }

      mount.innerHTML = '<div class="awq-wrap">' + html + '</div>';
      wire();
    }

    function chip(group, key, label) {
      var active = state[group] === key;
      var count = group === 'theme' ? countTheme(key) : countSeason(key);
      var color = (group === 'theme' && TM[key]) ? TM[key].color : '#9b8fa6';
      return '<button class="awq-chip' + (active ? ' is-active' : '') + '" data-' + group + '="' + key + '"'
        + (active ? ' style="border-color:' + color + ';color:' + color + '"' : '') + '>'
        + esc(label) + ' <span class="awq-chip-n">' + count + '</span></button>';
    }

    function card(q) {
      if (q.graphic) {
        return '<article class="awq-card awq-card--graphic">'
          + (q.image
              ? '<img src="' + esc(q.image) + '" alt="' + esc(q.caption) + '">'
              : '<div class="awq-card-missing">Graphic quote \u2014 add an image</div>')
          + '</article>';
      }
      var keys = themesOf(q);
      var bg = (q.image ? '<span class="awq-card-bg" style="background-image:url(' + esc(q.image) + ')"></span><span class="awq-card-scrim"></span>' : '');
      var tags = keys.map(function (k) {
        var t = TM[k] || TM.inspiration;
        return '<span class="awq-tag" style="color:' + t.color + '"><i class="awq-dot" style="background:' + t.dot + '"></i>' + esc(t.label) + '</span>';
      }).join('');
      return '<article class="awq-card">' + bg + '<div class="awq-card-inner">'
        + '<blockquote>\u201c' + esc(q.text) + '\u201d</blockquote>'
        + (q.author ? '<div class="awq-card-author">' + esc(q.author) + '</div>' : '')
        + '<div class="awq-card-foot"><span class="awq-tags">' + tags + '</span>'
        + '<button class="awq-share" data-share="' + esc(q.id) + '">Share</button></div>'
        + '<div class="awq-card-kicker">' + esc(kick(q)) + '</div>'
        + '</div></article>';
    }

    function wire() {
      var s = mount.querySelector('.awq-search');
      if (s) s.addEventListener('input', function (e) { state.q = e.target.value; state.spotlightId = null; var pos = e.target.selectionStart; render(); var n = mount.querySelector('.awq-search'); if (n) { n.focus(); try { n.setSelectionRange(pos, pos); } catch (x) {} } });
      mount.querySelectorAll('[data-theme]').forEach(function (b) { b.addEventListener('click', function () { state.theme = b.getAttribute('data-theme'); state.spotlightId = null; render(); }); });
      mount.querySelectorAll('[data-season]').forEach(function (b) { b.addEventListener('click', function () { var k = b.getAttribute('data-season'); state.season = (state.season === k) ? 'all' : k; state.spotlightId = null; render(); }); });
      mount.querySelectorAll('[data-share]').forEach(function (b) { b.addEventListener('click', function () { var id = b.getAttribute('data-share'); var q = DATA.filter(function (x) { return x.id === id; })[0]; if (q) share(q); }); });
      var rnd = mount.querySelector('[data-random]'); if (rnd) rnd.addEventListener('click', function () { var pool = DATA.filter(function (q) { return !q.graphic && isLive(q); }); if (!pool.length) pool = DATA.filter(isLive); if (!pool.length) pool = DATA; var pick = pool[Math.floor(Math.random() * pool.length)]; if (pool.length > 1 && pick.id === state.spotlightId) { pick = pool[(pool.indexOf(pick) + 1) % pool.length]; } state.spotlightId = pick.id; render(); });
      var clr = mount.querySelector('[data-clear]'); if (clr) clr.addEventListener('click', function () { state.spotlightId = null; render(); });
      var cf = mount.querySelector('[data-clearfilters]'); if (cf) cf.addEventListener('click', function () { state.q = ''; state.theme = 'all'; state.season = 'all'; state.spotlightId = null; render(); });
    }

    /* ---- boot: load data, then render ---------------------------------- */
    function start() {
      render();
      /* deep link ?q=<handle> spotlights one quote */
      try {
        var qp = new URLSearchParams(location.search).get('q');
        if (qp && DATA.filter(function (x) { return x.id === qp; })[0]) { state.spotlightId = qp; render(); }
      } catch (e) {}
    }

    boot();

    function boot() {
      // Local preview / fallback: data already injected on the page.
      if (Array.isArray(window.AW_QUOTES) && window.AW_QUOTES.length) {
        DATA = window.AW_QUOTES.slice();
        start();
        return;
      }
      if (!cfg.token || /PASTE|YOUR_TOKEN/i.test(cfg.token)) {
        showDiag('<strong>Storefront API token not set.</strong> In the theme editor, open this section and paste your '
          + 'Headless storefront’s <em>public</em> access token. Find it in Shopify admin under <strong>Sales channels '
          + '→ Headless →</strong> your storefront <strong>→ Storefront API tokens → Public access token</strong>.');
        return;
      }
      if (/^shpat_/i.test(cfg.token.trim())) {
        showDiag('<strong>That looks like the <em>private</em> token.</strong> A <code>shpat_…</code> token is the Headless '
          + '<em>private</em> access token — it’s for server-side use only, uses a different header, and must stay secret '
          + '(never put it in a theme). Use the <strong>public access token</strong> from the same storefront instead '
          + '(<strong>Sales channels → Headless →</strong> your storefront <strong>→ Storefront API tokens → Public '
          + 'access token</strong>).');
        return;
      }
      showLoading();
      fetchAllQuotes(cfg).then(function (quotes) {
        if (!quotes.length) { showDiag(zeroMsg()); return; }
        DATA = quotes;
        start();
      }).catch(function (err) {
        console.error('[words-archive]', err);
        showDiag('<strong>Couldn’t load quotes.</strong> ' + esc(err.message || String(err))
          + '<br><br>Check the token is a <em>Storefront</em> (not Admin) API token with the '
          + '<code>unauthenticated_read_metaobjects</code> scope, and that the API version (<code>'
          + esc(cfg.version || '2024-10') + '</code>) is valid.');
      });
    }

    /* ---- Storefront API: page through every quote metaobject ----------- */
    function fetchAllQuotes(c) {
      var endpoint = 'https://' + c.domain + '/api/' + (c.version || '2024-10') + '/graphql.json';
      var query = [
        'query Q($type: String!, $cursor: String) {',
        '  metaobjects(type: $type, first: 250, after: $cursor) {',
        '    edges { node {',
        '      handle',
        '      qt: field(key: "quote_text") { value }',
        '      au: field(key: "author") { value }',
        '      dt: field(key: "quote_date") { value }',
        '      oc: field(key: "occasion") { value }',
        '      cp: field(key: "caption") { value }',
        '      ig: field(key: "is_graphic") { value }',
        '      th: field(key: "themes") { value }',
        '      bg: field(key: "background_image") { value reference { __typename ... on MediaImage { image { url } } ... on GenericFile { url previewImage { url } } } references(first: 1) { nodes { __typename ... on MediaImage { image { url } } ... on GenericFile { url previewImage { url } } } } }',
        '    } }',
        '    pageInfo { hasNextPage endCursor }',
        '  }',
        '}'
      ].join('\n');
      var all = [];
      function page(cursor) {
        return fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': c.token
          },
          body: JSON.stringify({ query: query, variables: { type: c.type || 'quote', cursor: cursor } })
        }).then(function (r) { return r.json(); }).then(function (json) {
          if (json.errors && json.errors.length) {
            throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
          }
          var mo = json.data && json.data.metaobjects;
          if (!mo) return all;
          mo.edges.forEach(function (e) { all.push(mapNode(e.node)); });
          if (mo.pageInfo && mo.pageInfo.hasNextPage) return page(mo.pageInfo.endCursor);
          return all;
        });
      }
      return page(null);
    }

    function mapNode(n) {
      function v(k) { return n[k] && n[k].value != null ? n[k].value : ''; }
      var themes = [];
      try { themes = n.th && n.th.value ? JSON.parse(n.th.value) : []; }
      catch (e) { themes = n.th && n.th.value ? [n.th.value] : []; }
      var img = null;
      var bg = n.bg || {};
      // single file_reference, OR first node of a list.file_reference
      var refs = [bg.reference].concat((bg.references && bg.references.nodes) || []);
      for (var i = 0; i < refs.length; i++) {
        var r = refs[i];
        if (!r) continue;
        if (r.image && r.image.url) { img = r.image.url; break; }          // MediaImage
        if (r.url) { img = r.url; break; }                                  // GenericFile (svg/etc.)
        if (r.previewImage && r.previewImage.url) { img = r.previewImage.url; break; }
      }
      // last resort: the field value is already a URL (rare)
      if (!img && bg.value && /^https?:\/\//.test(bg.value)) img = bg.value;
      return {
        id: n.handle,
        text: v('qt'),
        author: v('au'),
        date: v('dt'),
        occasion: v('oc'),
        caption: v('cp'),
        graphic: v('ig') === 'true',
        themes: Array.isArray(themes) ? themes : [],
        image: img
      };
    }

    /* ---- diagnostic / loading boxes ------------------------------------ */
    function box(inner) {
      mount.innerHTML = '<div style="max-width:680px;margin:60px auto;padding:24px 28px;border:1px solid #e0d9ca;'
        + 'border-radius:14px;background:#fbf6ee;font-family:Jost,system-ui,sans-serif;color:#5c5340;line-height:1.65;">'
        + inner + '</div>';
    }
    function showLoading() { box('<div style="text-align:center;color:#8a8270;letter-spacing:.04em;">Loading the archive…</div>'); }
    function showDiag(inner) { box(inner); }
    function zeroMsg() {
      return '<strong>Connected, but zero quotes came back.</strong> Check, in order:'
        + '<ol style="margin:10px 0 0;padding-left:18px;">'
        + '<li>Settings &rarr; Custom data &rarr; Metaobjects &rarr; <em>Quote</em> &rarr; <strong>Access</strong> &rarr; enable <strong>Storefronts</strong>.</li>'
        + '<li>Each entry’s status is <strong>Active</strong> (not Draft).</li>'
        + '<li>The type handle matches <code>' + esc(cfg.type || 'quote') + '</code>.</li>'
        + '</ol>';
    }
  });

  function injectStyles() {
    if (document.getElementById('awq-styles')) return;
    var css = [
      '#words-archive{--ink:#23201a;--paper:#f6f3ee;font-family:Jost,system-ui,sans-serif;color:var(--ink);background:var(--paper);position:relative;-webkit-font-smoothing:antialiased;}',
      '#words-archive *{box-sizing:border-box;}',
      '.awq-wrap{max-width:1180px;margin:0 auto;padding:clamp(40px,6vw,90px) 26px 96px;}',
      '.awq-intro{text-align:center;max-width:760px;margin:0 auto;}',
      '.awq-eyebrow{font-family:Jost,sans-serif;font-size:13px;font-weight:600;letter-spacing:.3em;text-transform:uppercase;color:#8a86c9;margin-bottom:20px;}',
      '.awq-intro p{font-size:15px;line-height:1.75;color:#6f675a;margin:0;}',
      '.awq-hero{position:relative;overflow:hidden;text-align:center;max-width:900px;margin:clamp(34px,5vw,58px) auto 0;border:1px solid #e4d9c6;border-radius:26px;padding:clamp(36px,6vw,62px) clamp(24px,5vw,64px);}',
      '.awq-hero--graphic{padding:0;border:1px solid #e0dacc;background:#efece4;aspect-ratio:16/7;}',
      '.awq-hero--graphic img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}',
      '.awq-hero-bg{position:absolute;inset:0;background-size:cover;background-position:center;}',
      '.awq-hero-scrim{position:absolute;inset:0;background:rgba(252,248,240,.55);}',
      '.awq-hero-inner{position:relative;z-index:2;}',
      '.awq-hero-status{position:relative;z-index:3;display:inline-block;font-size:10.5px;letter-spacing:.24em;text-transform:uppercase;color:#7a715f;margin-bottom:14px;}',
      '.awq-hero--graphic .awq-hero-status{position:absolute;top:16px;left:50%;transform:translateX(-50%);background:rgba(255,255,255,.82);padding:5px 15px;border-radius:999px;}',
      '.awq-hero-kicker{display:flex;gap:11px;align-items:center;justify-content:center;font-size:11px;letter-spacing:.2em;text-transform:uppercase;margin-bottom:26px;}',
      '.awq-hero-quote{font-family:Newsreader,Georgia,serif;font-weight:300;font-style:italic;font-size:clamp(28px,4.4vw,52px);line-height:1.16;letter-spacing:-.01em;margin:0;color:var(--ink);}',
      '.awq-hero-author{margin-top:30px;font-size:12px;letter-spacing:.22em;text-transform:uppercase;color:#5f574a;}',
      '.awq-hero-note{margin-top:7px;font-family:Newsreader,Georgia,serif;font-style:italic;font-size:14px;letter-spacing:.01em;color:#8a8170;}',
      '.awq-hero-actions{display:flex;gap:24px;justify-content:center;flex-wrap:wrap;margin-top:26px;}',
      '.awq-link{appearance:none;border:none;background:none;cursor:pointer;font-family:Jost,sans-serif;font-size:13px;letter-spacing:.04em;color:var(--ink);padding:0 0 2px;border-bottom:1px solid #c2b9a8;}',
      '.awq-link--mauve{color:#9b8fa6;border-bottom-color:#d8cfe0;}',
      '.awq-link--mute{color:#a39a8a;border-bottom-color:transparent;}',
      '.awq-controls{margin-top:clamp(34px,4vw,52px);display:flex;flex-direction:column;gap:18px;}',
      '.awq-field{display:flex;align-items:center;gap:13px;}',
      '.awq-field>label{font-size:10.5px;letter-spacing:.18em;text-transform:uppercase;color:#a39a8a;white-space:nowrap;}',
      '.awq-search{flex:1 1 auto;border:none;border-bottom:1.5px solid #d8d2c6;background:transparent;font-family:Newsreader,Georgia,serif;font-style:italic;font-size:18px;padding:5px 0;color:var(--ink);outline:none;}',
      '.awq-filterline{display:flex;flex-wrap:wrap;align-items:center;gap:14px 30px;}',
      '.awq-chiprow{display:flex;gap:8px;flex-wrap:wrap;}',
      '.awq-chip{cursor:pointer;white-space:nowrap;border:1px solid #e0d8c8;background:#fff;border-radius:999px;padding:6px 12px;font-family:Jost,sans-serif;font-size:12px;letter-spacing:.02em;color:#6b6253;display:inline-flex;gap:6px;align-items:center;transition:all .15s;}',
      '.awq-chip.is-active{background:#fff;font-weight:500;}',
      '.awq-chip-n{font-size:11px;color:#bcb3a3;}',
      '.awq-archhead{display:flex;align-items:baseline;justify-content:space-between;gap:16px;flex-wrap:wrap;margin:clamp(40px,5vw,58px) 0 26px;border-top:1px solid #e4e0d6;padding-top:26px;}',
      '.awq-archhead h2{font-family:Newsreader,Georgia,serif;font-weight:400;font-size:25px;margin:0;}',
      '.awq-count{font-size:13px;color:#a39a8a;white-space:nowrap;}',
      '.awq-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:22px;align-items:start;}',
      '.awq-card{position:relative;overflow:hidden;width:100%;background:#fffdf9;border:1px solid #e7e2d8;border-radius:14px;transition:all .18s ease;}',
      '.awq-card:hover{border-color:#d6cdbb;box-shadow:0 10px 26px rgba(40,34,20,.07);transform:translateY(-2px);}',
      '.awq-card-bg{position:absolute;inset:0;background-size:cover;background-position:center;}',
      '.awq-card-scrim{position:absolute;inset:0;background:rgba(255,253,249,.62);}',
      '.awq-card-inner{position:relative;z-index:2;padding:26px 26px 22px;}',
      '.awq-card blockquote{font-family:Newsreader,Georgia,serif;font-size:19px;line-height:1.42;margin:0;color:#2a261f;}',
      '.awq-card-author{margin-top:18px;font-size:11px;letter-spacing:.2em;text-transform:uppercase;color:#6f675a;}',
      '.awq-card-foot{margin-top:16px;padding-top:14px;border-top:1px solid #efe9dc;display:flex;align-items:center;justify-content:space-between;gap:12px;}',
      '.awq-tags{display:inline-flex;gap:16px;flex-wrap:wrap;}',
      '.awq-tag{display:inline-flex;align-items:center;gap:8px;font-size:10.5px;letter-spacing:.14em;text-transform:uppercase;white-space:nowrap;}',
      '.awq-dot{width:7px;height:7px;border-radius:2px;transform:rotate(45deg);display:inline-block;flex:0 0 auto;}',
      '.awq-share{appearance:none;border:none;background:none;cursor:pointer;color:#b0a796;font-size:12px;font-family:Jost,sans-serif;letter-spacing:.04em;}',
      '.awq-card-kicker{margin-top:10px;font-size:10.5px;letter-spacing:.09em;color:#b6ac99;text-transform:uppercase;}',
      '.awq-card--graphic{aspect-ratio:1/1;background:#efece4;border:1px solid #e0dacc;}',
      '.awq-card--graphic img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;}',
      '.awq-card-missing{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#a99f8c;font-size:13px;text-align:center;padding:20px;}',
      '.awq-empty{text-align:center;padding:60px 20px;}',
      '.awq-empty-h{font-family:Newsreader,Georgia,serif;font-style:italic;font-size:24px;color:#6f675a;}',
      '.awq-clear{margin-top:16px;cursor:pointer;border:1px solid #c2b9a8;background:none;border-radius:999px;padding:10px 22px;font-family:Jost,sans-serif;font-size:13px;color:var(--ink);}',
      '.awq-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(16px);z-index:80;background:#241d12;color:#fbf6ee;padding:12px 22px;border-radius:999px;font-size:13px;opacity:0;pointer-events:none;transition:all .25s;box-shadow:0 12px 34px rgba(0,0,0,.28);}',
      '.awq-toast.is-on{opacity:1;transform:translateX(-50%) translateY(0);}'
    ].join('\n');
    var st = document.createElement('style');
    st.id = 'awq-styles';
    st.textContent = css;
    document.head.appendChild(st);
  }
})();
